export default __webpack_public_path__ + "resources/icons/n240-eef8.png";